import Tile from './Tile';

export { default as TrustJustification } from './TrustJustification';

export default Tile;
